<template>
  <section class="transfer">
    <div class="info overflow1 selltype">{{ infoData.selltype }}</div>
    <div class="info overflow1 annotime">{{ infoData.annotime }}</div>
    <div class="info overflow1 pmgz">
      限房价、定品质、竞地价、限价竞买、抽签竞得
    </div>
    <div class="info overflow1 pj">限房价、定品质、竞地价</div>
    <div class="info overflow1 ysyq">
      自取得施工许可证之日起9个月内申请办理预售
    </div>
    <div class="info overflow1 zxyq">
      成品住宅比例100%，基础装修标准不高于3000
    </div>
    <div class="info overflow1 fixedprice">{{ infoData.fixedprice }}</div>
    <div class="info overflow1 bond">{{ infoData.bond }}</div>
    <div class="info overflow1 dj">/</div>
    <div class="info overflow1 startfloorprice">
      {{
        infoData.startfloorprice == "/"
          ? infoData.startfloorprice
          : infoData.startfloorprice + "（元/㎡）"
      }}
    </div>
    <div class="info overflow1 startprice">
      {{
        infoData.startprice == "/"
          ? infoData.startprice
          : infoData.startprice + "（万元/亩）"
      }}
    </div>
    <div class="info overflow1 starttotalprice">
      {{
        infoData.starttotalprice == "/"
          ? infoData.starttotalprice
          : infoData.starttotalprice + "（万元）"
      }}
    </div>
    <div class="info overflow1 totalprice">
      {{
        infoData.totalprice == "/"
          ? infoData.totalprice
          : infoData.totalprice + "（万元）"
      }}
    </div>
    <div class="info overflow1 otherinfo">{{ infoData.otherinfo }}</div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      infoData: "",
    };
  },

  components: {},

  mounted() {
    this.bus.$on("setLandInfo", (val) => {
      this.infoData = val;
    });
  },

  methods: {},
};
</script>
<style lang='scss' scoped>
.transfer {
  width: 872px;
  height: 802px;
  background-image: url("./../../../assets/imgs/landInfo/transfer.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-top: 20px;
  .overflow1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-break: break-all;
  }
  .info {
    color: #fff;
    font-size: 32px;
    position: absolute;
  }
  .selltype {
    left: 220px;
    top: 78px;
  }
  .annotime {
    left: 624px;
    top: 78px;
  }
  .pmgz {
    left: 220px;
    top: 128px;
  }
  .pj {
    left: 366px;
    top: 175px;
  }
  .ysyq {
    left: 220px;
    top: 221px;
    -webkit-line-clamp: 2;
  }
  .zxyq {
    left: 220px;
    top: 312px;
    -webkit-line-clamp: 2;
  }
  .fixedprice {
    left: 280px;
    top: 410px;
  }
  .bond {
    left: 676px;
    top: 410px;
  }
  .dj {
    left: 280px;
    top: 453px;
  }
  .startfloorprice {
    left: 676px;
    top: 455px;
  }
  .startprice {
    left: 280px;
    top: 504px;
    max-width: 170px;
  }
  .starttotalprice {
    left: 676px;
    top: 504px;
  }
  .totalprice {
    left: 280px;
    top: 550px;
  }
  .otherinfo {
    left: 177px;
    top: 600px;
    -webkit-line-clamp: 4;
    max-width: 630px;
  }
}
</style>